import { render, staticRenderFns } from "./YouTube.vue?vue&type=template&id=14067c13&scoped=true&"
import script from "./YouTube.vue?vue&type=script&lang=js&"
export * from "./YouTube.vue?vue&type=script&lang=js&"
import style0 from "./YouTube.vue?vue&type=style&index=0&id=14067c13&lang=scss&scoped=true&"
import style1 from "./YouTube.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14067c13",
  null
  
)

export default component.exports